import React from 'react'
import View from './view'

const CommunityHome = ({ ...props }) => {
    return <View {...props} />
}

export default CommunityHome
